import { createApi } from '@reduxjs/toolkit/query/react';

import {
  Avatar,
  Supplier,
  SupplierActivity,
  SupplierSpotlight,
} from '@scaleup/models';
import { baseQuery } from './baseQuery';
import { TagTypes } from './tagTypes';

export const supplierApi = createApi({
  reducerPath: 'supplierApi',
  baseQuery: baseQuery,
  tagTypes: [
    TagTypes.supplier,
    TagTypes.supplierSpotlight,
    TagTypes.supplierActivity,
    TagTypes.supplierAvatar,
  ],
  endpoints: (builder) => ({
    getSupplier: builder.query<Supplier, string>({
      query: (id) => `/supplier/${id}`,
      providesTags: [TagTypes.supplier],
    }),

    getSupplierSpotlight: builder.query<SupplierSpotlight[], void>({
      query: () => `/supplier/spotlight`,
      providesTags: [TagTypes.supplierSpotlight],
    }),

    getSupplierAvatar: builder.query<Avatar, string>({
      query: (id) => `/supplier/avatar/${id}`,
      providesTags: (_result, _error, id) => [
        { type: TagTypes.supplierAvatar, id },
      ],
    }),

    getSupplierRequestMatchAvatars: builder.query<
      Record<string, Avatar>,
      string
    >({
      query: (requestId) => `/supplier_request/${requestId}/match/avatars`,
      providesTags: (_result, _error, id) => [
        { type: TagTypes.supplierAvatars, id },
      ],
    }),

    getSupplierActivity: builder.query<SupplierActivity[], void>({
      query: () => `/supplier/activity`,
      providesTags: [TagTypes.supplierActivity],
    }),
  }),
});

export const {
  useGetSupplierQuery,
  useLazyGetSupplierQuery,
  useGetSupplierSpotlightQuery,
  useGetSupplierActivityQuery,
  useGetSupplierAvatarQuery,
  useGetSupplierRequestMatchAvatarsQuery,
} = supplierApi;
